/** Ruta Angular + query + fragment para botones QUEES (PN/PJ). */
export interface ParaMiInternalLink {
  commands: string[];
  queryParams: Record<string, string>;
  fragment?: string;
}

/**
 * Interpreta urlForward de BX, p. ej.:
 * - /home?perfil=natural#home-crea-cuenta
 * - https://dominio/home?perfil=juridica#home-crea-cuenta
 */
export function parseParaMiInternalLink(
  url: string | null | undefined
): ParaMiInternalLink | null {
  const raw = (url ?? '').trim();
  if (!raw || raw.startsWith('#')) {
    return null;
  }

  let pathWithQuery = raw;
  let fragment: string | undefined;

  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      if (!isHomeAppPath(parsed.pathname)) {
        return null;
      }
      pathWithQuery = `${parsed.pathname}${parsed.search}`;
      fragment = parsed.hash ? parsed.hash.slice(1) : undefined;
    } catch {
      return null;
    }
  } else {
    const hashIdx = raw.indexOf('#');
    if (hashIdx >= 0) {
      pathWithQuery = raw.slice(0, hashIdx);
      fragment = raw.slice(hashIdx + 1) || undefined;
    }
  }

  const qIdx = pathWithQuery.indexOf('?');
  const pathPart = (
    qIdx >= 0 ? pathWithQuery.slice(0, qIdx) : pathWithQuery
  ).trim();
  const queryParams: Record<string, string> = {};
  if (qIdx >= 0) {
    new URLSearchParams(pathWithQuery.slice(qIdx + 1)).forEach((value, key) => {
      queryParams[key] = value;
    });
  }

  if (!pathPart || !isHomeAppPath(pathPart)) {
    if (pathPart && !/^https?:\/\//i.test(raw)) {
      const normalized = pathPart.startsWith('/') ? pathPart : `/${pathPart}`;
      return { commands: [normalized], queryParams, fragment };
    }
    return null;
  }

  return {
    commands: ['/home'],
    queryParams,
    fragment,
  };
}

/**
 * Comandos para routerLink:
 * - deep-link al Home → `[]` (misma ruta; aplica query/fragment)
 * - otra pantalla neo (`/login`, etc.) → esa ruta
 */
export function routerLinkCommandsForInternal(
  link: ParaMiInternalLink
): string[] {
  const cmd = (link.commands[0] ?? '').replace(/\/+$/, '') || '/';
  if (cmd === '/home' || cmd === 'home' || /(^|\/)home$/.test(cmd)) {
    return [];
  }
  return link.commands;
}

/** URL absoluta http(s) → externa (nueva pestaña), aunque apunte al home. */
export function isExternalParaMiUrl(url: string | null | undefined): boolean {
  return /^https?:\/\//i.test((url ?? '').trim());
}

function isHomeAppPath(pathname: string): boolean {
  return /(^|\/)home\/?$/.test(pathname.replace(/\/+$/, '') || '/');
}
